import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";
import DataReportList from "../../../components/DataReportList";

const dataReports_Content = [
  {
    format: bodyHelperTypes.paragraphs,
    order: 10,
    content: [
      <p className="mb-4 lead" style={{ fontSize: "1.1rem", color: "#333" }}>
        Click on <strong>"Display by Region"</strong> or{" "}
        <strong>"Display by Fiscal Year"</strong> below to choose a method for
        grouping the report's results, then select a report from one of the
        dropdown lists. The header above the list of reports indicates by which
        method the reports will be grouped.
      </p>,

      /* 1. Accessible Alert Box for the Note */
      <div
        className="alert alert-info d-flex align-items-start border-start border-4 border-info shadow-sm"
        role="alert"
      >
        <span className="me-3 fs-4" aria-hidden="true">
          ℹ️
        </span>
        <div>
          <strong className="d-block mb-1">Note:</strong>
          <p className="mb-0">
            These reports open in a separate tab, so you may have to
            <span className="fw-bold"> disable your popup blocker </span>
            or allow popups from this site. The reports will take a minute to
            load.
            <span className="sr-only"> (Opens in new window)</span>
          </p>
        </div>
      </div>,

      /* 2. Clear spacing before the list component */
      <div className="mt-5 border-top pt-4">
        <DataReportList />
      </div>,
    ],
  },
];

export default dataReports_Content;
